import { Alert } from "flowbite-react";
import { HiInformationCircle } from "react-icons/hi";

const semRetorno = (fonte) =>
  fonte?.statusRetorno === 0 || fonte?.statusRetorno === "0";

// A Relinq devolve cada fonte com o seu statusRetorno; 0 é fonte que falhou.
export const fonteDisponivel = (fonte) =>
  fonte && !semRetorno(fonte) ? fonte : null;

// `fontes` mapeia a chave do módulo para o nome exibido. `semLaudo` indica que
// a resposta chegou sem o bloco principal que a tela monta.
const FontesSemRetorno = ({ modulos, fontes, semLaudo = false }) => {
  if (!modulos) return null;

  const nomes = Object.entries(fontes)
    .filter(([key]) => semRetorno(modulos[key]))
    .map(([, nome]) => nome);
  const blocos = Object.keys(modulos).filter((key) => key !== "resumoRetorno");

  if (!nomes.length && !semLaudo) return null;

  return (
    <Alert color="warning" icon={HiInformationCircle} className="mb-3">
      {nomes.length > 0 && (
        <span className="font-medium">
          Fontes sem retorno nesta consulta: {nomes.join(", ")}.
        </span>
      )}
      {semLaudo && (
        <span className="block">
          Sem o bloco principal de crédito não há laudo para exibir
          {blocos.length > 0 && ` (blocos recebidos: ${blocos.join(", ")})`}.
        </span>
      )}
    </Alert>
  );
};

export default FontesSemRetorno;
